<template>
  <div class="member">
    <van-cell-group>
      <van-cell title="头像" @click="afterRead">
        <van-icon
        slot="right-icon"
        :name="params.avatar_url"
        style="line-height: inherit;"
        />
      </van-cell>
      <van-field
      v-model="params.username"
      clearable
      label="昵称"
      placeholder="请输入用户名"
      @input="checkName"
      maxlength='8'
      />
      <van-field
      v-model="params.sexName"
      label="性别"
      right-icon="arrow"
      placeholder="请选择性别"
      @click="showPickerd"

      />
      <van-field
      v-model="params.hometown"
      clearable
      label="家乡"
      right-icon="arrow"
      placeholder="请选择家乡"
      @click="showAread"
      />
      <van-field
      v-model="params.intro"
      clearable
      label="签名"
      placeholder="请输入签名"
      @input="checkIntro"
      maxlength='14'
      />
      <van-field
      v-model="params.reg_time"
      clearable
      label="注册时间"
      disabled
      input-align="right"
      />
    </van-cell-group>
    <van-action-sheet :round='false' v-model="showPicker" :actions="columns" @select="onSelect" />

    <van-popup v-model="showArea" position="bottom">
      <van-area 
      v-show="showArea" 
      :area-list="areaList" 
      @cancel="showArea = false"
      @confirm="onConfirmArea" />

    </van-popup>
    <div class="text-c">
      <van-button round size="large" @click="updateInfo" :disabled="submitbtn" color="#605C6B">保存</van-button>
    </div>
  </div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import AreaList from '../../../libs/area';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Image, Icon, Field, Picker, Area ,Cell, CellGroup, Popup, Button, Uploader,ActionSheet } from 'vant';
  export default {
    data(){
      return{
        params:{
         username:'',
         hometown:'',
         intro:'',
         sex:'',
         sexName:'男',
         avatar:'',
         avatar_url:''
       },
       showPicker:false,
       showArea:false,
       areaList:AreaList,
       columns:[{ name: '男' },
       { name: '女' },],
       submitbtn:true,
     }   
   },
   computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    this.getMemberInfo();
    var params={
      event_code: '我的信息',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/MemberInfo.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    getMemberInfo(){
      member.getMemberInfo({source:this.source}).then(res => {
        if(res.data.state == 1) {
          this.params=res.data.data
          if(this.params.province){
            this.params.hometown=this.params.province.name+this.params.city.name+this.params.district.name
            this.params.province_id=res.data.data.province.id
            this.params.city_id=res.data.data.city.id
            this.params.area_id=res.data.data.district.id
          }
          if(res.data.data.sex==1){
            this.params.sexName='男'
          }else{
           this.params.sexName='女' 
         }
         this.params.avatar_url=res.data.data.avatar
         this.params.avatar=''
       }
     })
    },
    showPickerd(e){
     this.showPicker = true;
   },
   onSelect(item) {
    this.params.sexName = item.name;
    if(item.name=='男'){
      this.params.sex =1
    }else{
      this.params.sex =2
    }
    this.showPicker = false;
    this.submitbtn=false
  },
  showAread(e){
    this.showArea=true;
  },
  onConfirmArea(value){
    this.params.hometown=value[0].name+value[1].name+value[2].name;
    this.params.province_id=value[0].code;
    this.params.city_id=value[1].code;
    this.params.area_id=value[2].code;
    this.showArea=false;
    this.submitbtn=false;
  },
  afterRead(file) {
    var params={
      type:2
    }
    this.$appService.openPhotoAlbum(params,v => {
      console.log('openPhotoAlbum=='+v.pic_url)
      this.params.avatar_url=v.pic_url
      this.params.avatar=v.pic
      this.submitbtn=false
    })
    // let params = new FormData()
    // params.append('img', file.file)
    // params.append('type',2)
    // member.uploadImg(params).then(res => {
    //   if(res.data.state == 1) {
    //     this.params.avatar_url=res.data.data.img_url
    //     this.params.avatar=res.data.data.img
    //     this.submitbtn=false
    //   }
    // })
  },
  checkName(value){
    this.submitbtn=false
    this.params.username=value
  },
  checkIntro(value){
    this.submitbtn=false
    this.params.intro=value
  },
  updateInfo(){
    this.params.bg=''
    this.params.source = this.source
    member.updateInfo(this.params).then(res => {
      if(res.data.state == 1) {
       this.$toast.success('修改成功');
       this.getMemberInfo()
     }
   })
  },
},
components: {
  [Field .name]: Field ,
  [Image.name]:Image,
  [Icon.name]:Icon,
  [Picker.name]:Picker,
  [Area.name]:Area,   
  [CellGroup.name]:CellGroup,
  [Cell.name]:Cell,
  [Popup.name]:Popup,
  [Button.name]:Button,
  [Uploader.name]:Uploader,
  [ActionSheet.name]:ActionSheet 
}
}
</script>
<style lang="scss">
.member{
  img{
    object-fit:cover !important;
  }
  .van-cell{
    padding: 10px 15px;
    .van-icon__image{
      width: 40px;
      height: 40px;
      object-fit: cover;
      .van-image__img{
        border-radius: 30px;
        object-fit: cover;
      }
    }
    .van-cell__title, .van-cell__value{
      padding: 10px 0;
    }
  }
  .text-c{
    margin-top: 30px;
    .van-button--large{
      width: 90%;
      height: 42px;
      line-height: 2;
    }
    .mt-20{
      margin-top: 20px;
    }
  }
  .van-uploader{
    width: 100%;
    .van-uploader__input-wrapper{
      width: 100%;
    }
  }
}
</style>